
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import OnboardingSlide from '../OnboardingSlide.vue';
import {userService} from '../../../user/UserService';
import KeyboardSlideResultNotCompatible from 'src/modules/onboarding/slides/content/KeyboardSlideResultNotCompatible.vue';
import PlugKeyboardSlide from 'src/modules/onboarding/slides/content/PlugKeyboardSlide.vue';
import {midiDispatcher} from 'src/modules/midi/MidiDispatcher';
import * as Audio from 'src/modules/audio';
import {analyticsController} from 'src/modules/user/analytics/AnalyticsController';
import {onboardingChecklistController} from '../../checklist/OnboardingChecklistController';
import TeacherIcon from 'src/modules/teacher/TeacherIcon.vue';
import {isInMobileApp} from 'src/utils/MobileUtils';
import {getAssetItem} from 'src/utils/helpers';

@Component({
  components: {
    TeacherIcon,
    PlugKeyboardSlide,
    KeyboardSlideResultNotCompatible,
    OnboardingSlide,
  },
  methods: {getAssetItem},
})
export default class KeyboardSlide extends Vue {
  @Prop({default: false}) private fromCatchupSlide!: boolean;
  @Prop({default: false}) private fromOnboardingMission!: boolean;
  @Prop({default: false}) private fromOnboarding!: boolean;

  private keyboardInfoData = {
    digital: {
      title: 'Piano numérique / Synthétiseur',
      content: `
            <div>
              <div>Il doit être branché à une prise électrique pour fonctionner.</div>
              <div>Il produit du son via ses haut-parleurs intégrés.</div>
              <div>Il possède une prise USB ou une prise MIDI.</div>
            </div>
        `,
    },
    acoustic: {
      title: 'Piano acoustique',
      content: `
          <div>
            <div>Soit un piano droit, soit un piano à queue.</div>
            <div>Il possède des cordes qui génèrent le son et n'a pas besoin d'être branché à une prise électrique.</div>
          </div>
        `,
    },
    midi: {
      title: 'Clavier MIDI',
      content: `
          <div>
            <div>Comme une souris d'ordinateur, c'est un contrôleur.</div>
            <div>Il ne produit aucun son par lui-même.</div>
            <div>Il doit être relié à un logiciel de musique pour contrôler les sons.</div>
          </div>
        `,
    },
  };

  private step:
    | 'keyboardSelection'
    | 'keyboardSelected'
    | 'classic'
    | 'midi'
    | 'none'
    | 'doesNotKnow'
    | 'declarativeMode' = 'keyboardSelection';

  private infoDialog: 'classic' | 'midi' | 'digital' | 'none' | null = null;

  get keyboardType() {
    return userService.user.configurations.keyboardType;
  }

  get performanceTestValid() {
    return Audio.musicTranscriptionController.state.performanceTestValid;
  }

  get isPerformanceTestProcessing() {
    return Audio.musicTranscriptionController.state.isPerformanceTestProcessing;
  }

  mounted() {
    midiDispatcher.initMidiDispatcher();

    if (this.keyboardType !== 'none' && !this.fromOnboarding) {
      this.step = 'keyboardSelected';
    }
  }

  private showInfo(type: 'digital' | 'acoustic' | 'midi') {
    const infoData = {};

    this.infoTitle = infoData[type].title;
    this.infoContent = infoData[type].content;
    this.infoDialog = true;
  }

  private setSelectedKeyboardAndLaunchNextSlide(keyboardType: 'midi' | 'classic' | 'none-but-will-buy' | 'none') {
    userService.updateConfiguration('KEYBOARD_TYPE', keyboardType).then(() => {
      onboardingChecklistController.completeTask('equipment', !this.fromOnboardingMission);

      if (this.fromOnboardingMission || this.fromOnboarding) {
        this.$emit('loadNextSlide');
      } else {
        this.step = keyboardType === 'none' ? 'none' : keyboardType === 'classic' ? 'classic' : 'keyboardSelected';
      }
    });
  }

  private async makePerformanceTest() {
    analyticsController.logBasicAnalyticsEvent('started audio performance test', 'audio capture performance test', {
      source: 'onboarding',
    });
    await Audio.musicTranscriptionController.executePerformanceTest();
    if (isInMobileApp()) {
      // @ts-ignore
      this.MobileScreen.enterFullScreenMode();
    }
  }

  private reportPerformanceTest() {
    localStorage.audioCapturePerformanceOptimalPeriod = JSON.stringify({
      optimalPeriod: null,
      status: 'reported',
      executedAt: new Date(),
    });
    Audio.musicTranscriptionController.state.performanceTestValid = 'reported';
  }

  private noPiano() {
    this.reportPerformanceTest();
    this.$emit('close');
  }

  private plugPiano() {
    onboardingChecklistController.completeTask('plug_piano', true);
    this.reportPerformanceTest();
  }

  @Watch('step')
  logAnalytic() {
    analyticsController.logBasicAnalyticsEvent('switched to ' + this.step + ' slide', 'Keyboard onboarding');
  }
}
